import { Box, Text } from "@hawkins/components";
import { Dimensions } from "@hawkins/variables";
import { useTranslation } from "react-i18next";

import { TranslationNamespace } from "../../types";

type FieldHeaderProps = {
  title: string;
  desc?: string;
};
export const FieldHeader = ({ title, desc }: FieldHeaderProps) => {
  const { t } = useTranslation(TranslationNamespace.LEP);
  return (
    <Box marginTop={Dimensions.Space8} rowGap={Dimensions.Space4} display="grid">
      <Text bold level={1}> {t(title)} </Text>
      {desc && <Text colorVariant="faded">{t(desc)}</Text> }
    </Box>
  );
};